import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-6" }
const _hoisted_2 = { class: "text-lg mb-3" }
const _hoisted_3 = {
  key: 0,
  class: "border rounded-lg divide-y"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 1,
  class: "text-gray-500"
}
const _hoisted_6 = ["onSubmit"]
const _hoisted_7 = { class: "mb-4" }
const _hoisted_8 = {
  class: "input-form-label",
  for: "access-users"
}
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "flex gap-3" }

import { ref, watch, computed, onMounted } from "vue";
import { useStore } from "vuex";
import Modal from "@/components/common/Modal.vue";
import Button from "@/components/common/Button.vue";
import { DocumentFolderDataService } from "@/services";
import { FolderAccess } from "@/types/documents/folder/DocumentFolder";
import { UserGetters } from "@/store/modules/user/getters";
import { UserActions } from "@/store/modules/user/actions";
import { useToast } from "vue-toastification";
import { t } from "@/i18n";


export default /*#__PURE__*/_defineComponent({
  props: {
  show: { type: Boolean, default: false },
  folderId: { type: String, required: true },
},
  setup(__props, { emit }: { emit: ({ hide: [] }), expose: any, slots: any, attrs: any }) {

const props = __props





const store = useStore();
const toast = useToast();
const accessList = ref<FolderAccess[]>([]);
const selectedUserIds = ref<string[]>([]);
const loading = ref(false);

const usersDataProvider = computed(
  () => store.getters[UserGetters.GET_DATA_PROVIDER]
);

const availableUsers = computed(() => {
  const grantedIds = new Set(accessList.value.map((a) => a.userId));
  return usersDataProvider.value.items.filter(
    (user: { id: string }) => !grantedIds.has(user.id)
  );
});

async function loadAccess() {
  try {
    const response = await DocumentFolderDataService.getAccess(props.folderId);
    accessList.value = response.data.data;
  } catch (error: any) {
    toast.error(error.response?.data?.message || t("common.error"));
    accessList.value = [];
  }
}

async function grantAccess() {
  if (!selectedUserIds.value.length) return;
  loading.value = true;
  try {
    const response = await DocumentFolderDataService.grantAccess(
      props.folderId,
      selectedUserIds.value
    );
    toast.success(response.data.message);
    selectedUserIds.value = [];
    await loadAccess();
  } catch (error: any) {
    toast.error(error.response?.data?.message || t("common.error"));
  } finally {
    loading.value = false;
  }
}

async function revokeAccess(folderAccessId: string) {
  try {
    const response = await DocumentFolderDataService.revokeAccess(
      folderAccessId
    );
    toast.success(response.data.message);
    await loadAccess();
  } catch (error: any) {
    toast.error(error.response?.data?.message || t("common.error"));
  }
}

watch(
  () => props.show,
  async (visible) => {
    if (visible) {
      selectedUserIds.value = [];
      await loadAccess();
    }
  }
);

onMounted(async () => {
  await store.dispatch(UserActions.FETCH_DATA_PROVIDER);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    show: __props.show,
    title: _unref(t)('archive.folderAccess'),
    onClose: _cache[2] || (_cache[2] = ($event: any) => (emit('hide')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(t)("archive.currentAccess")), 1),
        (accessList.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accessList.value, (access) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: access.id,
                  class: "flex items-center justify-between px-4 py-2"
                }, [
                  _createElementVNode("span", null, _toDisplayString(access.username), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "text-red-600 text-sm hover:underline",
                    onClick: ($event: any) => (revokeAccess(access.id))
                  }, _toDisplayString(_unref(t)("common.delete")), 9, _hoisted_4)
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_unref(t)("common.noData")), 1))
      ]),
      _createElementVNode("form", {
        onSubmit: _withModifiers(grantAccess, ["prevent"])
      }, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("label", _hoisted_8, _toDisplayString(_unref(t)("archive.grantAccess")), 1),
          _withDirectives(_createElementVNode("select", {
            id: "access-users",
            class: "input-form w-full",
            multiple: "",
            size: "6",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedUserIds).value = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableUsers), (user) => {
              return (_openBlock(), _createElementBlock("option", {
                key: user.id,
                value: user.id
              }, _toDisplayString(user.surname) + " " + _toDisplayString(user.name) + " " + _toDisplayString(user.patronymic || ""), 9, _hoisted_9))
            }), 128))
          ], 512), [
            [_vModelSelect, selectedUserIds.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(Button, {
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('hide')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("common.close")), 1)
            ]),
            _: 1
          }),
          _createVNode(Button, {
            type: "submit",
            disabled: loading.value || !selectedUserIds.value.length
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("archive.grantAccessSubmit")), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ], 40, _hoisted_6)
    ]),
    _: 1
  }, 8, ["show", "title"]))
}
}

})